import { EditIcon } from '@chakra-ui/icons';
import { TbTrash } from 'react-icons/tb';

import { Image, Tooltip } from '@/components/v4';
import ActionsButton from 'components/tables/AGGrid/ActionsButton';
import { typeOptions } from './constants';

const getTypeLabel = (value) =>
    typeOptions.find((option) => option.id === String(value))?.name ??
    String(value ?? '');

/**
 * Builds the AG Grid column definitions for the Service Categories table.
 *
 * @param {object}   params
 * @param {function} params.onEditServiceCategory   Called with the row data when the edit action is clicked.
 * @param {function} params.onDeleteServiceCategory Called with the row data when the delete action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getServiceCategoriesTableColumns = ({
    onEditServiceCategory,
    onDeleteServiceCategory,
}) => [
    {
        headerName: 'Image',
        field: 'image',
        maxWidth: 100,
        sortable: false,
        filter: false,
        cellRenderer: (params) => (
            <Tooltip label={params.value} hasArrow>
                <Image
                    boxSize={5}
                    objectFit="contain"
                    src={
                        import.meta.env.DEV
                            ? `${import.meta.env.VITE_APP_IMAGE_BASE}/images/${params.value}`
                            : `${window.location.origin}/images/${params.value}`
                    }
                />
            </Tooltip>
        ),
    },
    {
        headerName: 'Type',
        field: 'type',
        maxWidth: 130,
        filter: false, // only one type exists currently; re-enable once more are added
        valueFormatter: (params) => getTypeLabel(params.value),
    },
    {
        headerName: 'ID',
        field: 'id',
        flex: 1,
        minWidth: 100,
        sort: 'asc',
    },
    {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Description',
        field: 'description',
        flex: 1,
        minWidth: 150,
        hide: true,
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsButton
                actions={[
                    {
                        label: 'Edit',
                        icon: EditIcon,
                        onClick: () => onEditServiceCategory(params.data),
                    },
                    {
                        label: 'Delete',
                        icon: TbTrash,
                        onClick: () => onDeleteServiceCategory(params.data),
                    },
                ]}
            />
        ),
    },
];
